import React from "react";
import { YAxis } from "interfaces/chart";
import { List, ListItemButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { MenuTooltip } from "components/DataExplorationV2/MenuTooltip";

export interface CurrentAxesProps {
  yAxes: YAxis[] | null;
  selectedYAxis: YAxis | null;
  onChangeSelectedYAxis: (yAxis: YAxis) => void;
}

export const CurrentAxes = ({
  yAxes,
  selectedYAxis,
  onChangeSelectedYAxis
}: CurrentAxesProps): JSX.Element => {
  return (
    <div aria-label="Current Y-Axes Wrapper">
      <CurrentAxesSubtitle>Additional Y Axes</CurrentAxesSubtitle>
      {yAxes && yAxes?.length > 0 ? (
        <StyledList>
          {yAxes.map((axis: YAxis) => {
            return (
              <StyledListItemButton
                key={`Series_${axis.id}`}
                aria-label="current-series-row"
                selected={
                  selectedYAxis !== null && axis.id === selectedYAxis?.id
                }
                onClick={() => onChangeSelectedYAxis(axis)}
              >
                <MenuTooltip title={axis.title.text}>
                  <YAxisTitle>{axis.title.text}</YAxisTitle>
                </MenuTooltip>
              </StyledListItemButton>
            );
          })}
        </StyledList>
      ) : null}
    </div>
  );
};

const CurrentAxesSubtitle = styled("div")`
  display: flex;
  margin: ${({ theme }) => theme.spacing(0.5)} 0;
  font-size: 0.75rem;
  align-items: center;
  justify-content: space-between;
`;

const StyledList = styled(List)`
  font-size: 0.75rem;
  margin: 0 -${({ theme }) => theme.spacing(2)} !important;
  padding: 0 ${({ theme }) => theme.spacing(2)};
`;

const StyledListItemButton = styled(ListItemButton)`
  height: 36px;
  &.MuiListItemButton-root:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
  &.MuiListItemButton-root.Mui-selected {
    background-color: rgba(0, 0, 0, 0.1);
  }
  &.MuiListItemButton-root.Mui-selected:hover {
    background-color: rgba(0, 0, 0, 0.15);
  }
`;

const YAxisTitle = styled("div")`
  word-break: break-word;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
